const TwoUsersIcon = ({ fill, className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.09896 1.875C5.91283 1.875 4.14062 3.64721 4.14062 5.83333C4.14062 8.01946 5.91283 9.79167 8.09896 9.79167C10.2851 9.79167 12.0573 8.01946 12.0573 5.83333C12.0573 3.64721 10.2851 1.875 8.09896 1.875ZM5.39063 5.83333C5.39063 4.33756 6.60319 3.125 8.09896 3.125C9.59473 3.125 10.8073 4.33756 10.8073 5.83333C10.8073 7.3291 9.59473 8.54167 8.09896 8.54167C6.60319 8.54167 5.39063 7.3291 5.39063 5.83333Z"
        fill={fill || "#D1A855"}
      />
      <path
        d="M13.099 1.875C12.7538 1.875 12.474 2.15482 12.474 2.5C12.474 2.84518 12.7538 3.125 13.099 3.125C14.5947 3.125 15.8073 4.33756 15.8073 5.83333C15.8073 7.3291 14.5947 8.54167 13.099 8.54167C12.7538 8.54167 12.474 8.82149 12.474 9.16667C12.474 9.51184 12.7538 9.79167 13.099 9.79167C15.2851 9.79167 17.0573 8.01946 17.0573 5.83333C17.0573 3.64721 15.2851 1.875 13.099 1.875Z"
        fill="#D1A855"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.64062 15.8333C1.64062 13.187 3.78593 11.0417 6.43229 11.0417H9.76562C12.412 11.0417 14.5573 13.187 14.5573 15.8333C14.5573 17.099 13.5313 18.125 12.2656 18.125H3.93229C2.66664 18.125 1.64062 17.099 1.64062 15.8333ZM6.43229 12.2917C4.47628 12.2917 2.89062 13.8773 2.89062 15.8333C2.89062 16.4086 3.357 16.875 3.93229 16.875H12.2656C12.8409 16.875 13.3073 16.4086 13.3073 15.8333C13.3073 13.8773 11.7216 12.2917 9.76562 12.2917H6.43229Z"
        fill={fill || "#D1A855"}
      />
      <path
        d="M14.7656 11.0417C14.4204 11.0417 14.1406 11.3215 14.1406 11.6667C14.1406 12.0118 14.4204 12.2917 14.7656 12.2917C16.7216 12.2917 18.3073 13.8773 18.3073 15.8333C18.3073 16.4086 17.8409 16.875 17.2656 16.875H16.0156C15.6704 16.875 15.3906 17.1548 15.3906 17.5C15.3906 17.8452 15.6704 18.125 16.0156 18.125H17.2656C18.5313 18.125 19.5573 17.099 19.5573 15.8333C19.5573 13.187 17.412 11.0417 14.7656 11.0417Z"
        fill={fill || "#D1A855"}
      />
    </svg>
  );
};

export default TwoUsersIcon;
